import { Grid, Button, Typography, Link, Divider, CircularProgress } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { useReactToPrint } from "react-to-print";
import { commonService } from '../../../../../services';
import { paymentService } from '../../e_razor-pay/model/e_razor-pay-service';
import PaymentConfirmationContent from './_payment-confirmation-content';
import { history } from "../../../../../helpers/history"
import { routePaths } from '../../../../config/route-paths';
import PaymentConfirmationHeader from './_payment-confirmation-header';
import { saveAs } from 'file-saver';
import { useMediaQuery } from 'react-responsive';
import { useTranslation } from "react-i18next";
import { Skeleton } from '@material-ui/lab';
import moment from "moment";


const useStyles = makeStyles((theme) => ({
    whiteColor: {
        color: theme.palette.eWhite.base
    },
    buttonStyle: {
        "&:hover": {
            backgroundColor: theme.palette.ePrimary.base,
        },
        background: theme.palette.ePastelColor2.base,
        color: theme.palette.eWhite.base,
        borderRadius: 29,
        justifyContent: "center",
        marginBottom: "1%"
    },
    printButton: {
        marginRight: "1%"
    },
    downloadButton: {
        marginLeft: "1%"
    },
    printDisplay: {
        display: "none",
    },
    paymentConfirmationHeader: {
        color: theme.palette.eSecondary.base,
        fontSize: "140%",
        marginTop: "30px",
        fontWeight: "900"
    },
    supportBtn: {
        "&:hover": {
            backgroundColor: theme.palette.ePrimary.base,
        },
        backgroundColor: theme.palette.ePastelColor2.base,
        color: theme.palette.eWhite.base + " !important",
        marginRight: "13px",
        borderRadius: 29
    },
    retryBtn: {
        "&:hover": {
            backgroundColor: theme.palette.ePastelColor2.base,
        },
        backgroundColor: theme.palette.ePrimary.base,
        color: theme.palette.eWhite.base + " !important",
        borderRadius: 29
    },
    textPayment: {
        paddingLeft: "25px",
        paddingRight: "25px",
    },
    subTitle: {
        color: theme.palette.eDark.base + " !important",
    },
    requestHelp: {
        width: "40%"
    },
    retryPayment: {
        width: "50%"
    },
    printReceiptGrid: {
        marginBottom: "2rem"
    },
    printPDFContainer: {
        marginTop: "5%"
    },
    printHeader: {
        fontSize: "x-large",
        paddingTop: "1%"
    },
    logoStyle: {
        maxWidth: "10rem"
    },
}))

export default function PostPaymentHandling({ response, accountId, location, paymentError,postData }) {
    const classes = useStyles()
    const [appLogo, setAppLogo] = useState(null);
    const [clientLogo, setClientLogo] = useState(null);
    const [isDownloading, setIsDownloading] = useState(false);
    const componentRef = useRef();
    const isTabletOrMobile = useMediaQuery({ query: "(min-width: 550px)" });
    const REQUEST_CANCELLED_URL ="REQUEST_CANCELLED_URL"
    const RETRY_ALLOWED ="RETRY_ALLOWED"
    const RETRY_NOT_ALLOWED ="RETRY_NOT_ALLOWED"
    const failure ="failure"
    const INTERNAL_ERROR ="INTERNAL_ERROR"
    const RETRY_NOT_ALLOWED_FAILED_C2M_API="RETRY_NOT_ALLOWED_FAILED_C2M_API"
    let languageCode = useSelector(
        (store) =>
            store?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
    );
    let labels = useSelector(
        (store) => store?.labels?.data?.getLabels?.E_AUTH_PAYMENT_CONFIRMATION
    );
    let appLogoCode = useSelector((store) => store?.parametersWidgets?.ParameterLookup?.E_IMPRESACX_LOGO);
    let clientLogoCode = useSelector((store) => store?.parametersWidgets?.ParameterLookup?.E_CLIENT_LOGO);
    const YEAR_DATE_FORMAT = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.E_DATE_MONTH_YEAR_FORMAT)
    const TIMESTAMP_DATE_FORMAT = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.TIMESTAMP_DATE_FORMAT)
    // const getPaymentReceipt = () => {
    //     setIsDownloading(true);
    //     let accountId = response?.mainData?.head?.accountId;
    //     let paymentId = response?.mainData?.paymentInfo?.output?.customOutput?.field1?.name === "payId"
    //         ? response?.mainData?.paymentInfo?.output?.customOutput?.field1?.value
    //         : null
    //     let paymentDateTime = response?.mainData?.paymentInfo?.input?.paymentDateTime
    //     let amount= localStorage.getItem('amount');
    //     let gettransactionDate=localStorage.getItem('transactionDate');
    //     let transactionDate= moment(gettransactionDate,TIMESTAMP_DATE_FORMAT).format(YEAR_DATE_FORMAT);
    //     let customerNumber=localStorage.getItem('accountId');
    //     paymentService.getPaymentReceipt(accountId, languageCode, amount,transactionDate,customerNumber,paymentId).
    //         then(res => {
    //             saveAs(res.data.getBase64DocumentAuthClient, getFileName(customerNumber, paymentDateTime));
    //             setIsDownloading(false);
    //         }).catch(() => {
    //             setIsDownloading(false);
    //         })
    // }
    const getPaymentReceipt = () => {
        setIsDownloading(true);
        let customerNumber=localStorage.getItem('accountId');
        paymentService.getAuthPaymentReceipt(postData?.PaymentEventId).
            then(res => {
                saveAs(`data:application/pdf;base64,${res.data.getAuthPaymentReceipt}`, getFileName(customerNumber));
                setIsDownloading(false);
            }).catch(() => {
                setIsDownloading(false);
            })
    }
    
    const getFileName = (accountId) => {
        return `${accountId}${labels?.E_AUTH_PAYMENT_CONFIRMATION_RECEIPT_DOWNLOAD_FILENAME}.pdf`;
    }
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });
    useEffect(() => {
        if (!appLogo && appLogoCode) {
            commonService.getAssestUrl(appLogoCode).then((response) => {
                setAppLogo(response);
            });
        }
        if (!clientLogo && clientLogoCode) {
            commonService.getAssestUrl(clientLogoCode).then((response) => {
                setClientLogo(response);
            });
        }
    }, [appLogoCode, clientLogoCode]);
    const supportTicketCall = () => {
        history.push(routePaths.GET_SUPPORT);
    };
    const {t:label, ready: labelReady} = useTranslation("label-E_NESCO_PAYMENT")
    return (
        <>
            {isTabletOrMobile ? (
                <>
                    {postData?.status === RETRY_NOT_ALLOWED ||
            postData?.status === RETRY_ALLOWED || postData?.status === INTERNAL_ERROR || postData?.statusMessage === failure || postData?.statusMessage === REQUEST_CANCELLED_URL ? (
              postData?.status === INTERNAL_ERROR || postData?.status === RETRY_NOT_ALLOWED ? ( null
                            // <>
                            //     <Grid container
                            //     >
                            //         <Grid item>
                            //             <Button
                            //                 variant="contained"
                            //                 className={classes.supportBtn}
                            //                 onClick={supportTicketCall}
                            //             >
                            //                 {labelReady ? label("E_PAYMENT_REQUEST_HELP") : <Skeleton />}
                            //             </Button>
                            //         </Grid>
                            //     </Grid>
                            // </>
                        ) : (
                            <React.Fragment>
                                <Grid container direction="row">
                                    {/* <Grid item>
                                        <Button
                                            variant="contained"
                                            className={classes.supportBtn}
                                            onClick={supportTicketCall}
                                        >
                                            {labelReady ? label("E_PAYMENT_REQUEST_HELP") : <Skeleton />}
                                        </Button>
                                    </Grid> */}
                                    <Grid item>
                                        <Button
                                            variant="contained"
                                            className={classes.retryBtn}
                                            onClick={() => { history.push(routePaths.QUICK_PAY); }}
                                        >
                                            {labels?.E_AUTH_PAYMENT_CONFIRMATION_RETRY_PAYMENT}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </React.Fragment>
                        )
                    ) : (
                        <Grid container direction="row" alignItems="left"
                        >
                            <Grid item xs={12}>
                                <Button variant="contained"
                                    className={[classes.buttonStyle, classes.printButton]}
                                    onClick={handlePrint}>
                                    {labels?.E_AUTH_PAYMENT_CONFIRMATION_PRINT_RECEIPT}
                                </Button>
                                <Button variant="contained"
                                    className={[classes.buttonStyle, classes.downloadButton]}
                                    onClick={getPaymentReceipt}>
                                    {labels?.E_AUTH_PAYMENT_CONFIRMATION_DOWNLOAD_RECEIPT}
                                    {isDownloading && (<>&nbsp;<CircularProgress size={18} className={classes.whiteColor} /></>)}
                                </Button>
                            </Grid>
                        </Grid>
                    )}
                </>
            ) : (
                <>
                    {postData?.status === RETRY_NOT_ALLOWED ||
            postData?.status === RETRY_ALLOWED || postData?.status === INTERNAL_ERROR || postData?.statusMessage === failure || postData?.statusMessage === REQUEST_CANCELLED_URL ? (
              postData?.status === INTERNAL_ERROR || postData?.status === RETRY_NOT_ALLOWED || postData?.status === RETRY_NOT_ALLOWED_FAILED_C2M_API? ( null
                            // <>
                            //     <Grid container
                            //         align="center"
                            //     >
                            //         <Grid item
                            //             xs={12}
                            //         >
                            //             <Button
                            //                 variant="contained"
                            //                 className={classes.supportBtn}
                            //                 onClick={supportTicketCall}
                            //             >
                            //                 {labelReady ? label("E_PAYMENT_REQUEST_HELP") : <Skeleton />}
                            //             </Button>
                            //         </Grid>
                            //     </Grid>
                            // </>
                        ) : (
                            <React.Fragment>
                                <Grid container
                                    direction="column"
                                    align="center"
                                >
                                    {/* <Grid item
                                        xs={12}
                                    >
                                        <Button
                                            variant="contained"
                                            className={`${classes.supportBtn} ${classes.requestHelp}`}
                                            onClick={supportTicketCall}
                                        >
                                            {labelReady ? label("E_PAYMENT_REQUEST_HELP") : <Skeleton />}
                                        </Button>
                                    </Grid> */}
                                    <Grid item
                                        xs={12}
                                    >
                                        <Button
                                            variant="contained"
                                            className={`${classes.retryBtn} ${classes.retryPayment}`}
                                            onClick={() => { history.push(routePaths.QUICK_PAY); }}
                                        >
                                            {labels?.E_AUTH_PAYMENT_CONFIRMATION_RETRY_PAYMENT}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </React.Fragment>
                        )
                    ) : (
                        <Grid container
                            align="center" className={classes.printReceiptGrid}
                        >
                            <Grid item xs={12}>
                                <Button variant="contained"
                                    className={[classes.buttonStyle, classes.printButton]}
                                    onClick={handlePrint}>
                                    {labels?.E_AUTH_PAYMENT_CONFIRMATION_PRINT_RECEIPT}
                                </Button>
                                <Button variant="contained"
                                    className={[classes.buttonStyle, classes.downloadButton]}
                                    onClick={getPaymentReceipt}>
                                    {labels?.E_AUTH_PAYMENT_CONFIRMATION_DOWNLOAD_RECEIPT}
                                    {isDownloading && (<>&nbsp;<CircularProgress size={18} className={classes.whiteColor} /></>)}
                                </Button>
                            </Grid>
                        </Grid>
                    )}
                </>
            )}
            <Grid container
                className={classes.printDisplay}>
                <Grid item
                    ref={componentRef}>
                    <Grid container justify="space-between" className={classes.printPDFContainer}>
                        <Grid item  xs={6} justify='left' alignContent="left" align='left'>
                            <img
                            className={classes.logoStyle}
                            src={clientLogo?.assetPath}
                            alt={labels?.E_AUTH_PAYMENT_CONFIRMATION_CLIENT_LOGO_FALL_BACK}
                            />
                        </Grid>
                        <Grid item  xs={6} justify='right' alignContent="right" align='right'>
                            <img
                            className={classes.logoStyle}
                            src={appLogo?.assetPath}
                            alt={labels?.E_AUTH_PAYMENT_CONFIRMATION_APP_LOGO_FALL_BACK}
                            />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography variant="h6"
                                align="center"
                                className={classes.paymentConfirmationHeader}>
                                <b>
                                    {labels?.E_AUTH_PAYMENT_CONFIRMATION_SUCCESS}
                                </b>
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12}>
                            <Divider className={classes.dividerColor} />
                            <PaymentConfirmationContent
                                postData={postData}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}